import React, { useState, useEffect, useCallback } from "react";

import {
  RideGlArrowBack,
  RideGrid,
  RideIconButton,
  RideButton,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";

import history from "@/utils/history";

import "./styles.scss";
import { QUESTION_MODEL } from "@/features/Comprar/vida-endosable/step-plans/models/model";
import { ModalQuestionList } from "../ModalQuestionList/index";
import helpers from "@/utils/helpers";
import { getProductOptions, getScreenName } from "@/utils/product";
import { processRoutes } from '@/utils/newStepperVE'

export const NewStepperVE = ({
  routeMain,
  routes: baseRoutes = [],
}) => {
  const { digitalDataProductName } = getProductOptions();
  const [openQuestion, setOpenQuestion] = useState(false);
  const userData = useSelector((state) => state.vida.userData);
  const isSuscriptionEnabled = useSelector((state) => state.vida.suscription.enabled);
  const {
    currentRouteName,
    currentStep,
    routeNames,
    percentageCompleted,
  } = processRoutes({
    baseRoutes,
    isSuscriptionEnabled,
  });

  const goBack = useCallback(() => {
    history.push(routeNames[currentStep - 2] ?? routeMain);
  }, [routeNames, routeMain, currentStep]);

  const handleQuestionClick = () => {
    const screenName = getScreenName();

    helpers.setActionTag({
      group: digitalDataProductName,
      category: screenName,
      action: "click",
      label: "Dudas frecuentes",
    });
    
    hideCloseEmbedded(true);
    setOpenQuestion(true);
  };

  const hideCloseEmbedded = (open) => {
    helpers.sendMessageToApp(open ? "EMBEDDED-APP-HIDE-TOPBAR" : "EMBEDDED-APP-SHOW-TOPBAR");
  }

  const handleBackClick = () => {
    const screenName = getScreenName();

    helpers.setActionTag({
      group: digitalDataProductName,
      category: screenName,
      action: "click",
      label: "Atras",
    });
    goBack();
  };

  useEffect(() => {
    window.addEventListener("popstate", goBack);

    return () => {
      window.removeEventListener("popstate", goBack);
    };
  }, [goBack]);

  return (
    <>
      <div className="new-stepper-ve_mob">
        <RideGrid className="new-stepper-ve_mob--grid">
          <div className="new-stepper-ve_mob--content">
            <div className="flex items-center flex-1 gap-ride-gl-spacing-2xlarge">
              <RideIconButton
                glyph={<RideGlArrowBack />}
                variant="unfill"
                size="large"
                onClick={handleBackClick}
              />
              <div className="flex flex-col flex-1 w-100 gap-ride-gl-spacing-medium">
                <span className="ride-sys-text-label-small-semibold">
                  {currentRouteName}
                </span>
                <div className="new-stepper-ve_mob--content-bar">
                  {routeNames.map((_, index) => (
                    <div
                      key={index}
                      className={`new-stepper-ve_mob--content-bar-fill ${
                        index >= currentStep ? "bg-ride-sys-color-surface-medium" : ""
                      }`}
                      style={{ width: `${100 / routeNames.length}%` }}
                    />
                  ))}
                </div>
              </div>
            </div>
            <span>
              <RideButton
                text="¿Tienes dudas?"
                variant="text-primary"
                size="medium"
                className="w-max"
                onClick={handleQuestionClick}
              />
            </span>
          </div>
        </RideGrid>
      </div>

      <div
        className={`new-stepper-ve_desktop--bar ${
          userData?.indPrevPageApp ? "relative" : "sticky top-14"
        }`}
      >
        <div
          className="new-stepper-ve_desktop--bar-fill"
          style={{ width: `${percentageCompleted}%` }}
        ></div>
      </div>

      <RideGrid className="hidden lg:grid">
        <div className="new-stepper-ve_desktop--content">
          <span>
            Paso {currentStep} de {routeNames.length}
          </span>
        </div>
      </RideGrid>

      <ModalQuestionList
        {...QUESTION_MODEL}
        isOpen={openQuestion}
        setIsOpen={(e) => {
          setOpenQuestion(e);
          if (!e) hideCloseEmbedded(false);
        }}
      />
    </>
  );
};
